<template>
  <div class="container">
    <!-- Tab 选项 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="出售中" name="selling"></el-tab-pane>
      <el-tab-pane label="已下架" name="soldout"></el-tab-pane>
    </el-tabs>

    <!-- 条件查询 -->
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="searchForm.name" placeholder="商品名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.id" placeholder="商品ID"></el-input>
      </el-form-item>
    </el-form>

    <!-- 新建商品按钮 -->
    <el-button type="primary" @click="createProduct">新建商品</el-button>

    <!-- 商品列表 -->
    <el-table :data="filteredProducts" style="width: 100%">
      <el-table-column prop="goodsImage" label="商品主图" width="140">
        <template slot-scope="scope">
          <img
            :src="scope.row.goodsImage"
            alt="商品主图"
            style="height: 80px; cursor: pointer; border-radius: 5px"
            @click="showLargeImage(scope.row.goodsImage)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="goodsName" label="商品名称" width="360">
        <template slot-scope="scope">
          {{ scope.row.goodsName }}
          <div
            style="color: #999999"
            class="copyable-id"
            @click="copyText(scope.row._id)"
            title="点击复制商品ID"
          >
            ID: {{ scope.row._id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsPrice"
        label="价格(￥)"
        width="110"
        sortable
        :sort-method="(a, b) => a.goodsPrice - b.goodsPrice"
      ></el-table-column>
      <el-table-column
        prop="goodsInventory"
        label="库存"
        width="110"
        sortable
        :sort-method="(a, b) => a.goodsInventory - b.goodsInventory"
      ></el-table-column>
      <el-table-column
        prop="goodsTotalSales"
        label="总销量"
        width="110"
        sortable
        :sort-method="(a, b) => a.goodsTotalSales - b.goodsTotalSales"
      ></el-table-column>
      <el-table-column
        prop="goods30daySales"
        label="30日销量"
        width="110"
        sortable
        :sort-method="(a, b) => a.goods30daySales - b.goods30daySales"
      ></el-table-column>
      <el-table-column
        :label="listLabel"
        width="200"
        sortable
        :prop="
          activeTab === 'selling'
            ? 'listTime'
            : activeTab === 'soldout'
            ? 'storageTime'
            : 'createTime'
        "
        :sort-method="
          (a, b) => {
            const prop =
              activeTab === 'selling'
                ? 'listTime'
                : activeTab === 'soldout'
                ? 'storageTime'
                : 'createTime';
            return String(a[prop] || '').localeCompare(String(b[prop] || ''));
          }
        "
      >
        <template slot-scope="scope">
          <span
            v-if="activeTab === 'selling' && scope.row.goodsStatus === '出售中'"
          >
            {{ scope.row.listTime ? scope.row.listTime : "未记录上架时间" }}
            <div style="color: green">出售中</div>
          </span>
          <span
            v-else-if="
              activeTab === 'soldout' && scope.row.goodsStatus === '已下架'
            "
          >
            {{
              scope.row.storageTime ? scope.row.storageTime : "未记录入库时间"
            }}
            <div style="color: red">已下架</div>
          </span>
          <span v-else-if="activeTab === 'all'">
            {{ scope.row.createTime }}
            <span v-if="scope.row.goodsStatus === '出售中'">
              <div style="color: green">出售中</div>
            </span>
            <span v-else-if="scope.row.goodsStatus === '已下架'">
              <div style="color: red">已下架</div>
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="editProduct(scope.row)"
            >编辑</el-button
          >
          <!-- 根据商品状态动态显示按钮 -->
          <el-button
            v-if="scope.row.goodsStatus === '出售中'"
            size="mini"
            @click="unlistProduct(scope.row)"
          >
            下架
          </el-button>
          <el-button
            v-else-if="scope.row.goodsStatus === '已下架'"
            size="mini"
            @click="relistProduct(scope.row)"
          >
            上架
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 大图查看对话框 -->
    <el-dialog :visible.sync="dialogVisible" width="50%" center>
      <img :src="largeImageUrl" alt="大图" style="width: 100%" />
    </el-dialog>

    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
  
<script>
export default {
  name: "GoodsManage",
  data() {
    return {
      activeTab: "selling", // 默认选中“出售中”
      searchForm: {
        name: "",
        id: "",
      },
      products: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      listLabel: "上架时间",
      dialogVisible: false,
      largeImageUrl: "",
    };
  },
  computed: {
    filteredProducts() {
      //依据产品状态筛选一个产品列表
      let result = this.products;
      if (this.activeTab !== "all") {
        // 根据 this.activeTab 的值确定要匹配的商品状态
        const statusMapping = {
          selling: "出售中",
          soldout: "已下架",
        };
        // 获取对应的商品状态字符串
        const status = statusMapping[this.activeTab];
        if (status) {
          result = result.filter((item) => item.goodsStatus === status);
        }
      }

      // 根据商品名称进行过滤
      if (this.searchForm.name) {
        const nameQuery = this.searchForm.name.toLowerCase();
        result = result.filter(
          (item) =>
            item.goodsName &&
            typeof item.goodsName === "string" &&
            item.goodsName.toLowerCase().includes(nameQuery)
        );
      }

      // 根据商品ID进行过滤
      if (this.searchForm.id) {
        const idQuery = this.searchForm.id.toString();
        result = result.filter(
          (item) =>
            item._id !== undefined && item._id.toString().includes(idQuery)
        );
      }

      // 2. 新增：根据Tab动态排序（核心修改）
      let sortField; // 排序字段：按Tab确定
      if (this.activeTab === "selling") {
        sortField = "listTime"; // 出售中 → 上架时间
      } else if (this.activeTab === "soldout") {
        sortField = "storageTime"; // 已下架 → 入库时间
      } else {
        sortField = "createTime"; // 全部 → 创建时间
      }

      // 倒序排序（时间戳大的在前，处理字段为undefined的情况）
      result.sort((a, b) => {
        // 转换时间为时间戳（无时间字段时设为0，排到最后）
        const timeA = a[sortField] ? new Date(a[sortField]).getTime() : 0;
        const timeB = b[sortField] ? new Date(b[sortField]).getTime() : 0;
        return timeB - timeA; // 倒序：timeB - timeA
      });

      return result;
    },
  },
  methods: {
    // 切换标签栏
    handleTabClick(tab) {
      if (tab.name === "all") {
        this.listLabel = "创建时间";
      } else if (tab.name === "selling") {
        this.listLabel = "上架时间";
      } else if (tab.name === "soldout") {
        this.listLabel = "下架时间";
      }
      // 清除搜索条件以确保切换标签时从头开始筛选
      this.resetSearch();
      this.fetchProducts(this.currentPage, this.pageSize); // 切换标签后重新加载数据
    },

    resetSearch() {
      // 清空搜索表单
      this.searchForm = {
        name: "",
        id: "",
      };
    },

    handleSizeChange(val) {
      this.pageSize = val;
      // 更新分页信息（每页xx条）并重新加载数据
      this.fetchProducts(this.currentPage, val);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // 更新分页信息（当前第x页）并重新加载数据
      this.fetchProducts(val, this.pageSize);
    },
    // 获取商品列表方法
    async fetchProducts(page = 1, limit = this.pageSize) {
      try {
        const params = {
          page,
          limit,
          status:
            this.activeTab !== "all"
              ? this.activeTab === "selling"
                ? "出售中"
                : "已下架"
              : null,
        };

        const response = await this.$http.get("/api/goods", {
          params,
        });

        if (response.data && response.data.pagination) {
          this.products = response.data.data;
          this.currentPage = response.data.pagination.currentPage;
          this.pageSize = response.data.pagination.itemsPerPage;
          this.total = response.data.pagination.totalItems;
        }
      } catch (error) {
        console.error("获取商品列表失败:", error); // 错误处理
      }
    },

    // 复制方法
    copyText(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$message({
            message: "复制成功",
            type: "success",
          });
        })
        .catch((err) => {
          this.$message.error("复制失败");
        });
    },

    // 打开新的浏览器标签页，新建商品
    createProduct() {
      // 假设你的应用根路径为 '/'
      const routeData = this.$router.resolve({ name: "NewGoods" });
      window.open(routeData.href, "_blank");
    },

    // 打开新的浏览器标签页，编辑商品
    editProduct(row) {
      // 假设你的应用根路径为 '/'
      const routeData = this.$router.resolve({
        name: "EditGoods",
        query: { id: row._id },
      });
      window.open(routeData.href, "_blank");
    },

    // 查看大图方法
    showLargeImage(imageUrl) {
      this.largeImageUrl = imageUrl;
      this.dialogVisible = true;
    },

    // 下架
    unlistProduct(row) {
      // 显示确认弹窗
      this.$confirm("确认下架？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            // 调用后端接口进行下架操作
            const response = await this.$http.put(
              `/api/goods/${row._id}/unlist`
            );
            if (response.status === 200) {
              this.$message.success("商品下架成功");
              // 刷新当前列表数据
              this.fetchProducts(this.currentPage, this.pageSize);
            } else {
              this.$message.error("商品下架失败，请稍后再试");
            }
          } catch (error) {
            console.error("Error during unlisting product:", error);
            this.$message.error("网络错误，请稍后再试");
          }
        })
        .catch(() => {
          this.$message.info("已取消下架");
        });
    },

    // 上架
    relistProduct(row) {
      // 显示确认弹窗
      this.$confirm("确认上架？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            // 调用后端接口进行上架操作
            const response = await this.$http.put(
              `/api/goods/${row._id}/relist`
            );
            if (response.status === 200) {
              this.$message.success("商品上架成功");
              // 刷新当前列表数据
              this.fetchProducts(this.currentPage, this.pageSize);
            } else {
              this.$message.error("商品上架失败，请稍后再试");
            }
          } catch (error) {
            console.error("Error during relisting product:", error);
            this.$message.error("网络错误，请稍后再试");
          }
        })
        .catch(() => {
          this.$message.info("已取消上架");
        });
    },
  },

  mounted() {
    // 在这里可以调用接口获取商品列表数据，并设置到 this.products
    this.fetchProducts(); // 在组件挂载后调用 fetchProducts 方法
  },
};
</script>

<style scoped>
.container {
  padding: 20px 20px 40px 20px;
  background-color: #fff;
}

.copyable-id {
  cursor: pointer; /* 鼠标悬停时的手型 */
  color: #409eff;
}
</style>